var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", bordered: false } },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 全平台在售的淘客商品。奖励由各商户自己承担、自己配置，平台不代配也不审核 —— 这里只用来看全平台放了哪些商品出来、奖励开到多少，发现异常配置时可以强制关闭。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商户" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: {
                      clearable: "",
                      placeholder: "商户 ID，留空为全部",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.merId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "merId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.merId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { clearable: "", placeholder: "商品名称" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "zone-switch" },
            [
              _c("span", { staticClass: "zone-switch-label" }, [
                _vm._v("App 门店专区展示奖励金额"),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "inactive-value": 0,
                  disabled: _vm.configSaving,
                },
                on: { change: _vm.saveZoneRewardShow },
                model: {
                  value: _vm.zoneRewardShow,
                  callback: function ($$v) {
                    _vm.zoneRewardShow = $$v
                  },
                  expression: "zoneRewardShow",
                },
              }),
              _c("span", { staticClass: "sub" }, [
                _vm._v(
                  " 关闭后用户看不到「团长 ¥5 / 代理 ¥3」这类标签，佣金仍按配置正常计算与发放 "
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "id", label: "配置ID", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { label: "商户", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.merName || "-"))]),
                        _c("div", { staticClass: "sub" }, [
                          _vm._v("ID：" + _vm._s(row.merId)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品", "min-width": "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "product-cell" },
                          [
                            row.image
                              ? _c("el-image", {
                                  staticClass: "product-image",
                                  attrs: { src: row.image, fit: "cover" },
                                })
                              : _vm._e(),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "product-name",
                                  attrs: { title: row.productName },
                                },
                                [_vm._v(_vm._s(row.productName))]
                              ),
                              _c("div", { staticClass: "sub" }, [
                                _vm._v("商品ID：" + _vm._s(row.productId)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "参加规格", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !row.scopeCount
                          ? _c("span", { staticClass: "sub" }, [
                              _vm._v("全部规格"),
                            ])
                          : _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "warning" } },
                              [_vm._v(_vm._s(row.scopeCount) + " 个规格")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "售价(元)", width: "95" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sales", label: "销量", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { label: "代理奖励", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.rewardText(
                              row.shareRewardType,
                              row.shareRewardValue
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "团长奖励", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.rewardText(
                              row.partnerRewardType,
                              row.partnerRewardValue
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                row.commissionOpen === 1 ? "success" : "info",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.commissionOpen === 1 ? "淘客中" : "已关闭"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "加入时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "110", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            class: { "danger-text": row.commissionOpen === 1 },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.toggle(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.commissionOpen === 1
                                  ? "强制关闭"
                                  : "重新开启"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.limit,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.load,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }